import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../../api/api.js';
import { isDemo, AppContext, WidgetsContext } from '../../../GlobalContex';
import useNotifications from '../../../hooks/useNotifications';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { ReactComponent as TikTokSvg } from '../../../assets/tiktok-image.svg';

const TikTokConnectButton = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const { setIsLoading, isEmbeded } = useContext(AppContext);
  const { activeWidget, setActiveWidgetSettings, activeWidgetMeta } = useContext(WidgetsContext);
  const { sendEvent } = useAnalytics();

  const TikTokButton = props => {
    return (
      <div
        className="container mb-3"
        style={{ cursor: 'pointer', border: '1px solid black', 'borderRadius': '3px' }}
        onClick={connectTikTok}
      >
        <div className="row">
          <div className="col d-flex">
            <TikTokSvg style={{ width: '10%', height: 'auto' }} />
            <span style={{ width: '90%', alignSelf: 'center', padding: '10px' }}>
              {props.children}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const connectTikTok = async () => {
    setIsLoading(true);
    try {
      const payload = await api.connectTikTokAccount(
        activeWidgetMeta.connectAccountUrl || `apps/tiktok-feed/widgets/${activeWidget.id}/data`,
        { preview: isDemo, withTracking: isEmbeded() }
      );
      sendEvent('connect_account', {
        account: 'tiktok'
      });
      setActiveWidgetSettings(payload);
    } catch (err) {
      notification.error(err.message);
    }
    setIsLoading(false);
  };

  if (activeWidget?.settings?.account) {
    return (
      <>
        <TikTokButton>{t('Change TikTok Account')}</TikTokButton>
        <div>
          {t('Connected')}: {activeWidget.settings.account.username}
        </div>
      </>
    );
  }
  return (
    <>
      <TikTokButton>{t('Connect TikTok Account')}</TikTokButton>
    </>
  );
};

export default TikTokConnectButton;